module.exports = __webpack_public_path__ + "media/npc_dota_hero_shadow_shaman.6f3b9389.webm";